(function(EF, undefined) {

  var Section = Backbone.Model.extend({
    initialize: function(attrs, options) {
      this.parse(attrs);
    },
    parse: function(json) {
      this.questions = new EF.Collections.QuestionsCollection(json.questions);
      delete json.questions;
      return json;
    }
  });

  _.extend(EF.Models, {
    Section: Section
  });

})(EF);
